<template>
  <Protect :permissions="[SYS_PERMISSIONS.SYS_BILLING_MANAGE]">
    <div
      v-if="isPastDue"
      class="fixed top-0 left-0 right-0 bg-neutral-900 text-center text-neutral-300 text-sm py-2 z-50 border-b border-primary-400"
    >
      <AlertTriangle class="inline stroke-error-400" />
      Your subscription payment failed. Please update your payment method to
      avoid service disruption.
      <RouterLink
        :to="{ name: 'workspace-billing', query: { paymentMethod: true } }"
        class="text-error-400 hover:text-error-400"
        >Update payment details</RouterLink
      >
    </div>
  </Protect>
</template>

<script setup>
import Protect from '@/hoc/Protect.vue';
import { SYS_PERMISSIONS } from '@/constants.js';
import { AlertTriangle } from 'lucide-vue-next';
import { RouterLink } from 'vue-router';
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const isPastDue = computed(() => {
  return store.getters['workspace/getIsPastDue'];
});
</script>
